import React, { FunctionComponent } from "react";
import { graphql } from "gatsby";
import { Layout } from "../../components/layout";
import { PageHeader } from "../../components/pageHeader";
import { ProjectCard } from "../../components/projectCard";
import { SEO } from "../../components/seo";
import {
  ProjectPartNode,
  ProjectSummaryNode,
  toProjectSummaries,
} from "../../data/posts";

export const pageQuery = graphql`
  {
    projects: allMarkdownRemark(
      sort: { fields: [frontmatter___title], order: ASC }
      filter: { fields: { collection: { eq: "projects" } } }
    ) {
      nodes {
        ...ProjectSummary
      }
    }
    projectParts: allMarkdownRemark(
      filter: {
        fields: { collection: { eq: "blog" } }
        frontmatter: { projects: { elemMatch: { part: { gt: 0 } } } }
      }
    ) {
      nodes {
        ...ProjectPart
      }
    }
  }
`;

interface Page {
  data: {
    projects: { nodes: ProjectSummaryNode[] };
    projectParts: { nodes: ProjectPartNode[] };
  };
}

const DECK = "Builds that take more than one post, in the order they happened.";

export const Page: FunctionComponent<Page> = ({ data }) => {
  const projects = toProjectSummaries(
    data.projects.nodes,
    data.projectParts.nodes
  );
  return (
    <>
      <SEO
        title="Projects"
        description={DECK}
        image={projects[0]?.img.src || "/logo.png"}
      />
      <Layout>
        <PageHeader title="Projects" deck={DECK} />
        <div className="grid grid-cols-1 gap-8 px-gutter-sm pb-14 md:grid-cols-2 md:px-gutter lg:grid-cols-3">
          {projects.map((project) => (
            <ProjectCard {...project} key={project.slug} />
          ))}
        </div>
      </Layout>
    </>
  );
};

export default Page;
